import React, { useState } from 'react';
import { Menu } from 'lucide-react';
import Sidebar from './Sidebar';
import NotificationBell from '../NotificationBell';
import { useLanguage } from '../../context/LanguageContext';

export default function Layout({ children }) {
  const { isRtl } = useLanguage();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div style={{ display:'flex', minHeight:'100vh' }}>
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      {sidebarOpen && <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} />}
      <main className="app-main" style={{ flex:1, [isRtl ? 'marginRight' : 'marginLeft']:240, padding:'32px', minHeight:'100vh' }}>
        <div style={{ display:'flex', alignItems:'center', marginBottom:20 }}>
          <button className="mobile-menu-btn" onClick={() => setSidebarOpen(true)} aria-label="Open menu">
            <Menu size={20} />
          </button>
          <div style={{ marginLeft:'auto' }}>
            <NotificationBell />
          </div>
        </div>
        {children}
      </main>
    </div>
  );
}
